import React, { useCallback, useRef, useState, useEffect } from "react";
import { useIntl } from "react-intl";

import scrollTo, { getBodyElement } from "../../../common/helpers/scrollTo";
import Seo from "../../../common/helpers/seo";

import Hero from "./Hero";
import Features from "./Features";
import TaskTypes from "./TaskTypes";
import Why from "./Why";
import Pride from "./Pride";
import Reviews from "./Reviews";

import { StyledHome } from "./styles";
import messages from "./messages";
import MobileApp from "./MobileApp";

const Home = () => {
    const { formatMessage } = useIntl();
    const taskTypes = useRef<HTMLDivElement>(null);
    const [showAll, setShowAll] = useState(false);
    const scrollToTaskTypes = useCallback(() => {
        setTimeout(
            () => {
                scrollTo(taskTypes.current!.getBoundingClientRect().top + getBodyElement().scrollTop - 40, 2500);
            },
            showAll ? 0 : 500
        );
        if (!showAll) {
            setShowAll(true);
            window.removeEventListener("scroll", handleScroll);
        }
    }, [showAll]);

    const handleScroll = useCallback(() => {
        const doc = document.documentElement;
        const scrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        if (scrollTop > 1000) {
            setShowAll(true);
            window.removeEventListener("scroll", handleScroll);
        }
    }, [setShowAll]);

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <StyledHome marginTop={50} withShadow>
            <Seo title={`Musicators - ${formatMessage(messages.slogen)}`} />
            <Hero scrollToTaskTypes={scrollToTaskTypes} />
            <Why />
            <Features />
            {showAll && (
                <>
                    <TaskTypes />
                    <div ref={taskTypes}>
                        <Pride />
                    </div>
                    <Reviews />
                </>
            )}
        </StyledHome>
    );
};

export default Home;
